import {
  Autocomplete,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  createFilterOptions,
} from "@mui/material";
import { radii, colors } from "../../../theme/designTokens";

const defaultFilterOptions = createFilterOptions();

// Shared search+filter bar, extracted from the near-identical duplicated
// Autocomplete-as-search block previously copy-pasted across admin list
// screens (ManageMedicine.jsx, CustomerList.jsx).
export default function SearchFilterBar({
  options,
  getOptionLabel,
  renderOption,
  onChange,
  label,
  multiple = false,
  optionsLimit = 12,
  defaultValue,
  value,
  filterSelect, // optional: { value, onChange, options: [{value,label}], label }
}) {
  const filterOptions = (opts, state) =>
    defaultFilterOptions(opts, state).slice(0, optionsLimit);

  return (
    <Grid container spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
      <Grid item xs={12} sm={filterSelect ? 8 : 12}>
        <Autocomplete
          multiple={multiple}
          options={options}
          defaultValue={defaultValue}
          {...(value !== undefined ? { value, isOptionEqualToValue: (option, selected) => option._id === selected._id } : {})}
          filterOptions={filterOptions}
          getOptionLabel={getOptionLabel}
          onChange={onChange}
          renderOption={renderOption}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: radii.md,
              "&.Mui-focused fieldset": {
                border: `1px solid ${colors.primary}`,
              },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
            />
          )}
        />
      </Grid>
      {filterSelect && (
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small">
            <InputLabel>{filterSelect.label}</InputLabel>
            <Select
              value={filterSelect.value}
              label={filterSelect.label}
              onChange={filterSelect.onChange}
              sx={{ borderRadius: radii.md }}
            >
              {filterSelect.options.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
}
